<div class="modal-content">
    <div class="modal-header">
        <h3 class="fzas-modal-title m-0">Editar Centro</h3>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"(click)="salir(false)"></button>
    </div>
    <form [formGroup]="nuevoCentroForm" (ngSubmit)="onSubmit()">
    <div class="modal-body">

            <div class="row">
                <div class="col-8">
                <label for="centCodigoCompania" class="form-label fzas-text-input">ID Centro</label>
                <input 
                type="text" 
                formControlName="centCodigoCompania" 
                name="centCodigoCompania" 
                placeholder="Escribe el ID del Centro" 
                class="form-control" 
                
                (input)="validarAlfanumerico($event, 'centCodigoCompania')" />
                <small *ngIf="mensajeErrorCodigo" class="text-danger small-text">{{ mensajeErrorCodigo }}</small>
            </div>
            <div class="col-4">
                <label for="centIniciales" class="form-label fzas-text-input">Iniciales Centro</label>
                <input 
                type="text" 
                formControlName="centIniciales"
                name="centIniciales" 
                placeholder="Sin Iniciales" 
                class="form-control"
                (input)="validarAlfanumerico($event, 'centIniciales')"
                />
            </div>
        </div>
            <div class="col-12 mt-3">
                <label for="centNombreCentro" class="form-label fzas-text-input">Nombre Centro</label>
                <input 
                    type="text" 
                    formControlName="centNombreCentro" 
                    name="centNombreCentro" 
                    placeholder="Escribe el nombre del Centro" 
                    class="form-control" 
                    
                    (input)="validarAlfanumerico($event, 'centNombreCentro')"/>
                <small *ngIf="mensajeErrorNombre" class="text-danger small-text">{{ mensajeErrorNombre }}</small>
            </div>
            <div class="row">
            <div class="col-6 mt-3">
                <label for="centSociedad" class="form-label fzas-text-input">Sociedad</label>
                <select 
                  formControlName="centSociedad"
                  placeholder="seleccione la Sociedad"
                  class="form-control fzas-custom-select" 
                  (change)="onSociedadChange()">
                  <option value="">Seleccione Sociedad</option>
                  <option *ngFor="let sociedad of sociedades" [ngValue]="sociedad">{{ sociedad.socSociedad }}</option>
                </select>
              </div>
              <div class="col-6 mt-3">
                <label for="centSegmento" class="form-label fzas-text-input">Segmento</label>
                <select 
                  formControlName="centSegmento" 
                  placeholder="seleccione la Sociedad"
                  class="form-control fzas-custom-select">
                  <option value="">Seleccione Segmento</option>
                  <option *ngFor="let segmento of segmentos" [value]="segmento.seg_segmento">{{ segmento.seg_segmento }}</option>
                </select>
              </div>
            </div>
              
            <!-- <div class="col-12 mt-3">
                (blur)="verificarExistenciaCampo('centNombreCentro')"  para validadr por input
                (blur)="verificarExistenciaCampo('centCodigoCompania')" 
                <label for="centCentroCosto" class="form-label fzas-text-input">Centro de Costo</label>
                <input 
                    type="text" 
                    formControlName="centCentroCosto" 
                    name="centCentroCosto" 
                    placeholder="Escribe el centro de costo" 
                    class="form-control"
                    (input)="validarAlfanumerico($event, 'centCentroCosto')"/>
            </div> -->
            
            <div class="col-12 mt-3">
                <label for="centAnalistaFinanzas" class="form-label fzas-text-input">Analista Finanzas</label>
                <p-autoComplete 
                (onSelect)="onAnalistaSelect($event)"  
                [suggestions]="suggestions" 
                (completeMethod)="search($event)" 
                formControlName="centAnalistaFinanzas" 
                placeholder="Escribe el nombre del Analista" 
                field="us_nombres">
              </p-autoComplete>
              <div *ngIf="noAnalistaFound" class="text-danger mt-2">
                No se encontraron resultados para el nombre ingresado.
              </div>
            </div>
            <div class="col-12 mt-3">
                <label for="flexSwitchCheckDefault" class="form-label fzas-text-input">Activación centro</label>
                <div class="form-switch d-flex align-items-center gap-2">
                    <input class="form-check-input mb-1" type="checkbox" role="switch" id="flexSwitchCheckDefault" formControlName="centActivado" (change)="onSwitchChange()">
                    <label class="form-check-label ms-1" for="flexSwitchCheckDefault" [ngClass]="switchLabel == 'Activado' ? 'fzas-switch-modal-blue' : 'fzas-switch-modal-grey'">{{ switchLabel }}</label>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="row">
                <div class="col-12 d-flex justify-content-end gap-3">
                    <button type="button" class="btn btn-cancelar-accion" (click)="salir(false)">Cancelar</button>
                    <button type="submit" class="btn btn-aplicar-accion">Aceptar</button>
                </div>
            </div>
        </div>
    </form>
</div>